import React, { Fragment, useContext } from 'react';
import styled, { css } from 'styled-components';
import HeaderContext from '../../HeaderContext';
import { HeaderCol } from '../../search/style';
import GetQuotesButton from './get-quotes-button';
import HeaderActions from './header-actions';
import HeaderLoggedIn from './header-loggedin';
import HamburgerMenu from './header-menu';

const HeaderGQButton = styled.div<{ hasSearch: Boolean; breakPoint: string }>`
  display: inline-block;
  ${props =>
    props.hasSearch &&
    css`
      @media (max-width: ${props => (props as any).breakPoint}) {
        display: none;
      }
    `};
`;

const HeaderRight: React.FC<{}> = () => {
  const { breakPoint, hasSearch, loginData, siteSource, shouldShowActions } = useContext(
    HeaderContext
  );
  /* eslint-disable react/forbid-component-props */
  return (
    <Fragment>
      <HeaderCol style={{ paddingRight: 20 }}>
        <HeaderActions />
        {shouldShowActions && (
          <HeaderGQButton breakPoint={breakPoint} hasSearch={hasSearch}>
            <GetQuotesButton siteSource={siteSource}>Get Quotes</GetQuotesButton>
          </HeaderGQButton>
        )}
        {loginData.logged_in && <HeaderLoggedIn />}
        <HamburgerMenu />
      </HeaderCol>
    </Fragment>
  );
};

export default HeaderRight;
